import {
  FETCH_NOTIFICATION_BANNERS_REQUEST,
  FETCH_NOTIFICATION_BANNERS_SUCCESS,
  FETCH_NOTIFICATION_BANNERS_FAILURE,
  SET_NOTIFICATION_BANNER_LOADING,
  CLEAR_NOTIFICATION_BANNER_ERROR,
  // Add site notifications action types
  FETCH_SITE_NOTIFICATIONS_REQUEST,
  FETCH_SITE_NOTIFICATIONS_SUCCESS,
  FETCH_SITE_NOTIFICATIONS_FAILURE,
  FETCH_SITE_NOTIFICATIONS_LOADING,
  // Add save notification action types
  SAVE_SITE_NOTIFICATION_REQUEST,
  SAVE_SITE_NOTIFICATION_SUCCESS,
  SAVE_SITE_NOTIFICATION_FAILURE,
} from "../actions/actionTypes";

interface NotificationBannerState {
  banners: any[];
  isLoading: boolean;
  error: boolean;
  // Add site notifications state
  siteNotifications: any[];
  siteNotificationsLoading: boolean;
  siteNotificationsError: any;
}

const initialState: NotificationBannerState = {
  banners: [],
  isLoading: true,
  error: false,
  // Add site notifications state
  siteNotifications: [],
  siteNotificationsLoading: true,
  siteNotificationsError: false,
};

const notificationBannerReducer = (
  state = initialState,
  action: { type: string; payload?: any }
): NotificationBannerState => {
  switch (action.type) {
    // Fetch banners
    case FETCH_NOTIFICATION_BANNERS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case FETCH_NOTIFICATION_BANNERS_SUCCESS:
      return {
        ...state,
        banners: action.payload,
        isLoading: false,
        error: false,
      };
    case FETCH_NOTIFICATION_BANNERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
      };

    // Utility actions
    case SET_NOTIFICATION_BANNER_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case CLEAR_NOTIFICATION_BANNER_ERROR:
      return {
        ...state,
        error: false,
      };

    // Site notifications cases
    case FETCH_SITE_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        siteNotificationsLoading: true,
        siteNotificationsError: false,
      };
    case FETCH_SITE_NOTIFICATIONS_LOADING:
      return {
        ...state,
        siteNotificationsError: false,
        siteNotificationsLoading: action.payload,
      };
    case FETCH_SITE_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        siteNotificationsLoading: false,
        siteNotificationsError: false,
        siteNotifications: action.payload,
      };

    case FETCH_SITE_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        siteNotificationsLoading: false,
        siteNotificationsError: action.payload,
      };

    // Save site notification cases
    case SAVE_SITE_NOTIFICATION_REQUEST:
      return {
        ...state,
        siteNotificationsLoading: true,
        siteNotificationsError: false,
      };
    case SAVE_SITE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        siteNotificationsLoading: false,
        siteNotificationsError: false,
      };
    case SAVE_SITE_NOTIFICATION_FAILURE:
      return {
        ...state,
        siteNotificationsLoading: false,
        siteNotificationsError: action.payload,
      };

    default:
      return state;
  }
};

export default notificationBannerReducer;